<template>
    <div id="iddwrapper">
        <div class="modal__content">
            <h2 class="content-subheading content-subheading--lg">Sind Sie sicher, dass Sie keine Hausnummer haben?</h2>
            <div style="width:100%;margin-top:20px">
                <a-btn primary white @click="close(false)" class="btn-small btn--white">Nein</a-btn>

                <a-btn primary  @click="close(true)" class="btn-small btn--blue float-right">Ja</a-btn>
            </div>
        </div>
        <button data-modal-close @tap="close(false)" @click="close(false)">
            <img src="@/assets/images/close.svg" height="20" width="20" alt="close icon"/>
            <span class="visually-hidden">Close modal</span>
        </button>
    </div>

</template>

<script>

export default {
  data () {
    return {
       

    }
  },

  methods: {

   
    close (useNumber) {
      this.$emit('done', useNumber)
    },
    
  }
}

</script>

<style scoped>


.custom-scrollbar {
    overflow-y:auto;
    overflow-x:hidden;
    height:auto;
    max-height: calc(100vh - 250px);
}
#iddScroll {
    position:relative;
    width:auto;
    height:100%;
}

#qustionFin {
    position:relative;
}

#iddwrapper{
    position:relative;
    height:100%;

}
.modal__content {
    height:100%;
    overflow:hidden;  
    max-height: calc(100vh - 250px);  
}
.tarif-select{
    margin-bottom:20px;
    
}

[data-modal-close] {
    right: 0;
    top: 0;
  } 
.input__box.sel-tarif{
    border-color:#014e9e;
    color:#014e9e;
    font-weight:bold;
}
.open-close__opener {
    display:none;
}
.icon-down-arrow{
    font-size:8px;
    color: #014e9e;
}
.btn-small {
    display: inline-block;
    vertical-align: top;
    color: #fff;
    font-weight: 700;
    font-size: 18px;
    text-transform: uppercase;
    min-width: 70px;
    width:45%;
    padding: 18px 20px 16px 20px;
    text-align: center;
    border: none;
    box-shadow: none;
    min-height: 56px;
}
.float-right{
    float:right;
}
@media (max-width: 850px) {
	.modal__content {
        max-height:60%;
        height:100%;
        overflow:hidden;  
        max-height: calc(100vh - 250px);  
        padding: 60px 60px 23px;
    }
}

@media (max-width: 650px) {
	.modal__content {
        padding: 20px 20px 20px;
    }
}

@media (max-width: 460px) {
	.modal__content {
        padding: 10px 10px 10px;
    }
}

@media (max-width: 725px) {
	.card__body.openClose{
        display:none;
    }
    .open-close__opener {
        display:inline-block;
        margin-bottom:10px;
    }

    .modal__content .cards {
        flex-direction: column;
        
    }
    .modal__content .cards .card {
        max-width:50%;
        margin-bottom:15px;
    }
    
}

</style>
